export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-windows-4b174e6e73642f9d645bfd52fcc5218c.svg";